module.exports = __webpack_public_path__ + "img/italy-tuberculosis-male.77ff74a3.png";